<div *ngIf="dataSource; else content">
    <div class="customiseDialogBox">
        <div fxLayout="row" fxLayoutAlign="center center" class="title">
            <h1 class="heading">{{ "designer.getCountDetails.heading.countInformation" | translate }}</h1>
            <a mat-dialog-close> <mat-icon class="close-icon">close</mat-icon></a>
        </div>
        <section class="example-container mat-elevation-z8">
            <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ "designer.getCountDetails.tableHeading.shapes" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>
                <!-- Combination Column -->
                <ng-container matColumnDef="facePattern">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ "designer.getCountDetails.tableHeading.facePattern" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.facePattern }}</td>
                </ng-container>

                <!-- Color Column -->
                <ng-container matColumnDef="color">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ "designer.getCountDetails.tableHeading.color" | translate }}
                    </th>
                    <td class="connection-data" mat-cell *matCellDef="let element">
                        <div *ngFor="let color of getFaceColors(element.color)">
                            <span
                                ><strong>{{ color.key }}:</strong></span
                            >
                            <span>&nbsp;&nbsp;{{ color.value }}</span>
                        </div>
                    </td>
                </ng-container>

                <!-- Count Column -->
                <ng-container matColumnDef="count">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ "designer.getCountDetails.tableHeading.count" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.count }}</td>
                </ng-container>

                <!-- Connection Data Column -->
                <ng-container matColumnDef="connectionDetails">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ "designer.getCountDetails.tableHeading.connectionData" | translate }}
                    </th>
                    <td class="connection-data" *matCellDef="let element">
                        <div *ngIf="element && element.connectionData">
                            <div *ngFor="let data1 of element.connectionData">
                                <span
                                    [ngClass]="{
                                        'bold-text':
                                            data1?.connectionType === 'Node' || data1?.connectionType === 'Hole'
                                    }"
                                >
                                    {{ data1?.face }} --- {{ data1?.connectionType }}
                                </span>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </section>
    </div>
</div>
<ng-template #content>
    <mat-progress-spinner class="example-margin" color="warn" mode="indeterminate" value="100"> </mat-progress-spinner>
</ng-template>
